export default __webpack_public_path__ + "static/media/folder-plus.0bcdaf76.svg";